import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  errorCode: null,
  data: {},
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setCategoryData(state, action) {
      state.status = action.payload.status;
      state.errorCode = action.payload.errorCode;
      state.data = action.payload.data;
    },
    clearCategoryData(state) {
      state.status = null;
      state.errorCode = null;
      state.data = null;
    },
  },
});

export const { setCategoryData, clearCategoryData } = categorySlice.actions;

export const selectCategoryData = (state) => state.category.data;

export default categorySlice.reducer;
